import { TenantEntity } from '../TenantEntity'

export class ContractConfig extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get officeId() {
    return this._data.officeId
  }
  set officeId(officeId) {
    this._data.officeId = officeId || 0
  }
  get warnDays() {
    return this._data.warnDays
  }
  set warnDays(warnDays) {
    this._data.warnDays = warnDays || 0
  }
  get warnAdmin() {
    return this._data.warnAdmin
  }
  set warnAdmin(warnAdmin) {
    this._data.warnAdmin = warnAdmin || false
  }
  get warnSale() {
    return this._data.warnSale
  }
  set warnSale(warnSale) {
    this._data.warnSale = warnSale || false
  }
  get forbidCreate() {
    return this._data.forbidCreate
  }
  set forbidCreate(forbidCreate) {
    this._data.forbidCreate = forbidCreate || false
  }
  get warnSupplierDirector() {
    return this._data.warnSupplierDirector
  }
  set warnSupplierDirector(warnSupplierDirector) {
    this._data.warnSupplierDirector = warnSupplierDirector || false
  }
  get warnCustomerService() {
    return this._data.warnCustomerService
  }
  set warnCustomerService(warnCustomerService) {
    this._data.warnCustomerService = warnCustomerService || false
  }

  get bellReminder() {
    return this._data.bellReminder
  }
  set bellReminder(bellReminder) {
    this._data.bellReminder = bellReminder || false
  }

  get mailReminder() {
    return this._data.mailReminder
  }
  set mailReminder(mailReminder) {
    this._data.mailReminder = mailReminder || false
  }
}
